<template>
  <div class="date-picker">
    <date-picker
      type="datetime"
      popup-class="custom-datepicker-popup"
      :confirm="true"
      :clearable="false"
      :editable="false"
      :confirm-text="confirmText"
      :placeholder="placeholder"
      :value="value"
      :disabled-date="disableBeforeToday"
      :disabled-time="disablePastHours"
      @change="handleChange"
    />
  </div>
</template>

<script>
import addDays from 'date-fns/addDays';
import DatePicker from 'vue2-datepicker';
export default {
  components: { DatePicker },
  props: {
    confirmText: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: Date,
      default: [],
    },
    canDisablePastHours: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
    disableBeforeToday(date) {
      const yesterdayDate = addDays(new Date(), -1);
      return date < yesterdayDate;
    },
    disablePastHours(date) {
      if (!this.canDisablePastHours) {
        return false;
      }

      return date < new Date();
    },
  },
};
</script>
<style lang="scss">
.custom-datepicker-popup {
  z-index: 9999 !important;
}
</style>
